import {Pipe, PipeTransform} from '@angular/core';

import {formatCount} from '../models/statistics-view.model';

/**
 * Anzahl im deutschen Zahlenformat, ohne Nachkommastellen.
 *
 * Statt DecimalPipe, weil die Anwendung keine Locale-Daten registriert und
 * `number: '1.0-0': 'de'` deshalb zur Laufzeit fehlschlagen wuerde.
 */
@Pipe({
  name: 'statCount',
  standalone: false
})
export class StatisticsCountPipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    if (value === null || value === undefined) {
      return '–';
    }
    return formatCount(value);
  }
}
